import { db } from "../../../service/API";

export class StatsConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
    this.players = userData.players;
  }

  filterPlayers(result) {
    let listPlayer = result;

    // FILTER PLAYERS ACCORDING TO USER ACCESS
    if (this.players.length > 0) {
      listPlayer = listPlayer.filter((player) => {
        return this.players.includes(player.value);
      });
    }

    return listPlayer;
  }

  sendData(stat) {
    return new Promise((resolve, reject) => {
      db.put("/StatsConnector/sendData", { stat: stat })
        .then((response) => {
          if (response.status == 200) {
            return resolve();
          } else {
            return reject("send stats data failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("send stats data failed with error : " + err.message);
        });
    });
  }

  /**
   * List all players with stats
   */
  getPlayers() {
    return new Promise((resolve, reject) => {
      db.post("/StatsConnector/listPlayers/", { sid: this.socId })
        .then((response) => {
          if (response.status == 200) {
            return resolve(this.filterPlayers(response.data));
          } else {
            return reject("get players list failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get players list failed with error : " + err.message);
        });
    });
  }

  /**
   * List all projects with stats
   */
  getProjects() {
    return new Promise((resolve, reject) => {
      db.post("/StatsConnector/listProjects/", { sid: this.socId })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get project list failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get project list failed with error : " + err.message);
        });
    });
  }

  /**
   * Get all projects playtime for the selected player
   * @param {Integer} pid Player id
   * @param {Object} period Object containing { start, end }
   */
  playtimePlayer(pid, period) {
    return new Promise((resolve, reject) => {
      db.post("/StatsConnector/playtimePlayer/", { pid: pid, period: period })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get playtime player failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get playtime player failed with error : " + err.message);
        });
    });
  }

  /**
   * Get all players playtime for the selected project
   * @param {String} pname Project name
   * @param {Object} period Object containing { start, end }
   */
  playtimeProject(pname, period) {
    return new Promise((resolve, reject) => {
      db.post("/StatsConnector/playtimeProject/", {
        pname: pname,
        period: period,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get playtime project failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get playtime project failed with error : " + err.message);
        });
    });
  }

  /**
   * Get all timeline for the selected player
   * @param {String} pid Player id
   * @param {Object} period Object containing { start, end }
   */
  timelinePlayer(pid, period) {
    return new Promise((resolve, reject) => {
      db.post("/StatsConnector/timelinePlayer/", { pid: pid, period: period })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get timeline project failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get timeline project failed with error : " + err.message);
        });
    });
  }

  /**
   * Get all timeline for the selected project
   * @param {String} pname Project name
   * @param {Object} period Object containing { start, end }
   */
  timelineProject(pname, period) {
    return new Promise((resolve, reject) => {
      db.post("/StatsConnector/timelineProject/", {
        pname: pname,
        period: period,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get timeline project failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get timeline project failed with error : " + err.message);
        });
    });
  }

  /**
   * Get days played for the selected player
   * @param {String} pid Player id
   * @param {Object} period Object containing { start, end }
   */
  daysPlayer(pid, period) {
    return new Promise((resolve, reject) => {
      db.post("/StatsConnector/daysPlayer/", { pid: pid, period: period })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get days played for player failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get days played for player failed with error : " + err.message);
        });
    });
  }

  /**
   * Get days played for the selected project
   * @param {String} pname Project name
   * @param {Object} period Object containing { start, end }
   */
  daysProject(pname, period) {
    return new Promise((resolve, reject) => {
      db.post("/StatsConnector/daysProject/", { pname: pname, period: period })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get days played for project failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get days played for project failed with error : " + err.message);
        });
    });
  }
}
